import { renderButton_unstable } from '@fluentui/react-button';
/**
 * Render the final JSX of BreadcrumbButton
 */ export const renderBreadcrumbButton_unstable = (state)=>{
    return renderButton_unstable(state);
};
